export const FLAVORS = [
    'chroma',
    'cottonCandy',
    'lemonLime',
    'pomegranate',
    'sunburst',
    'twilight',
    'wintergreen'
];
export const ACCENTS = [
    'blue',
    'blurple',
    'cyan',
    'green',
    'orange',
    'pink',
    'purple',
    'raspberry',
    'slate',
    'teal',
    'yellow'
];
export const THEMES = [
    'dark',
    'white',
    'light'
];
export const COLUMN_PADDING_SIZES = [
    'none',
    'small',
    'normal',
    'medium',
    'large',
    'xlarge'
];
export const ROW_GAP_SIZES = [
    'none',
    'small',
    'normal',
    'medium',
    'large',
    'xlarge',
    'xxlarge'
];

//# sourceMappingURL=constants.js.map